import { render, staticRenderFns } from "./Infomation.vue?vue&type=template&id=3b069536&scoped=true"
import script from "./Infomation.vue?vue&type=script&lang=js"
export * from "./Infomation.vue?vue&type=script&lang=js"
import style0 from "./Infomation.vue?vue&type=style&index=0&id=3b069536&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b069536",
  null
  
)

export default component.exports